import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import CategoriesCarousel from './CategoriesCarousel';

import LINKS from 'constants/links';

const BlogHeading = ({ categories, className, gaEventCategory, ...rest }) => (
  <>
    <div className={className} {...rest}>
      <Breadcrumb>
        <BreadcrumbItem href={LINKS.HOME}>
          {placeholder('breadcrumbs.promobit')}
        </BreadcrumbItem>
        <BreadcrumbItem>{placeholder('breadcrumbs.blog')}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <CategoriesCarousel
      categories={categories}
      gaEventCategory={gaEventCategory}
    />
  </>
);

BlogHeading.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      categoryName: PropTypes.string.isRequired,
      categorySlug: PropTypes.string.isRequired,
      categoryIcon: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default BlogHeading;
